import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ButtonBook = () => <FormattedMessage defaultMessage="Book more" id="components.Confirmation.buttonBook" />;
